<script setup lang="ts">
  import { useCarsStore } from '~/stores/CarsStore';
  const emit = defineEmits(['chooseSort']);
  const nuxtApp = useNuxtApp();
  const cars = useCarsStore();

	const prop = defineProps({
	  counter: { default: 0, type: [Number] },
    classList: { default: [], type: [Array] },
	})

  let filterParams = ref({
    transmissionFilter: '',
    yearFilter: '',
    engineFilter: '',
    seatsFilter: '',
    driveTypeFilter: '',
    mileageFilter: '',
    ratePerDayFilter: {
      price1: '',
      price2: '',
    },
    depositFilter: {
      price1: '',
      price2: '',
    },
    engineCapacityFilter: {
      value1: '',
      value2: '',
    },
  });

  const showFilters = ref(false);
  const showSort = ref(false);
  const sortPrice = ref('price_asc');
  const sortPriceName = ref('По умолчанию')


  const toggleFilters = () => {
  showFilters.value = !showFilters.value;

  if (showFilters.value && window.innerWidth < 761) {
    nuxtApp.$disablePageScroll();
  } else if (!showFilters.value && window.innerWidth < 761) {
    nuxtApp.$enablePageScroll();
  }
};

  const openSort = () => {
    showSort.value = !showSort.value
  }

  const setPriceSort = (item: string) => {
    if (sortPrice.value !== item) {
      sortPrice.value = item
      emit('chooseSort', item)
      if (item == 'price_desc') {
        sortPriceName.value = 'Сначала дороже'
      } else {
        sortPriceName.value = 'Сначала дешевле'
      }
    }
    openSort()
  }

  const clearFilters = () => {
    filterParams.value = {
      transmissionFilter: '',
      yearFilter: '',
      engineFilter: '',
      seatsFilter: '',
      driveTypeFilter: '',
      mileageFilter: '',
      ratePerDayFilter: {
        price1: '',
        price2: '',
      },
      depositFilter: {
        price1: '',
        price2: '',
      },
      engineCapacityFilter: {
        value1: '',
        value2: '',
      },
    };
  }
</script>

<template>
  <div class="filters">
    <div class="filters__top">
      <div class="filters__item line" style="position: relative;" @click="openSort"><span class="icon lines" :class="{'sort': sortPrice == 'price_asc'}"></span> {{ sortPriceName }}</div>
      <div v-if="showSort" class="filters__item line filters__item--menu">
        <a class="filters__item-menu-item" @click="setPriceSort('price_asc')"><span class="icon lines sort"></span> Сначала дешевле</a>
        <a class="filters__item-menu-item" @click="setPriceSort('price_desc')"><span class="icon lines"></span> Сначала дороже</a>
      </div>
      <div class="filters__text" v-show="!cars.loading && counter !== null">Найдено {{counter}} {{$getNumberLabels(counter, ['автомобиль','автомобиля','автомобилей'])}} </div>
      <div class="filters__item line" :class="{'active': showFilters == true}" @click="toggleFilters"><span class="icon filter"></span> Фильтр <span class="icon close"></span></div>
    </div>
    <form v-if="showFilters" class="filters__box" data-scroll-lock-scrollable>
      <div class="filters__box-top">
        <div class="filters__box-top-title">Фильтр</div>
        <div class="filters__box-close" @click="toggleFilters"></div>
      </div>
      <div class="filters__box-content">
        <div class="filters__box-row">
          <!-- <div class="filters__box-column">
            <div class="filters__box-part">
              <div class="filters__box-title">класс</div>
              <div class="filters__box-part-wrapper">
                <div class="filters__box-field">
                  <div class="custom-checkbox">
                    <input type="checkbox" name="class" id="comfort">
                    <label for="comfort"><span>Комфорт класс</span></label>
                  </div>
                </div>
                <div class="filters__box-field">
                  <div class="custom-checkbox">
                    <input type="checkbox" name="class" id="business">
                    <label for="business"><span>Бизнес</span></label>
                  </div>
                </div>
                <div class="filters__box-field">
                  <div class="custom-checkbox">
                    <input type="checkbox" name="class" id="promo">
                    <label for="promo"><span>Промо</span></label>
                  </div>
                </div>
                <div class="filters__box-field">
                  <div class="custom-checkbox">
                    <input type="checkbox" name="class" id="crossovers">
                    <label for="crossovers"><span>Кроссоверы</span></label>
                  </div>
                </div>
                <div class="filters__box-field">
                  <div class="custom-checkbox">
                    <input type="checkbox" name="class" id="luxury">
                    <label for="luxury"><span>Люкс</span></label>
                  </div>
                </div>
                <div class="filters__box-field">
                  <div class="custom-checkbox">
                    <input type="checkbox" name="class" id="suv">
                    <label for="suv"><span>Внедорожник</span></label>
                  </div>
                </div>
                <div class="filters__box-field">
                  <div class="custom-checkbox">
                    <input type="checkbox" name="class" id="minivans">
                    <label for="minivans"><span>Минивены</span></label>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="filters__box-column">
            <div class="filters__box-part">
              <div class="filters__box-title">коробка передач</div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Автомат
                  <input type="radio" checked value="AT" name="transmission" v-model="filterParams.transmissionFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Механика
                  <input type="radio" value="MT" name="transmission" v-model="filterParams.transmissionFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Любой
                  <input type="radio" value="any" name="transmission" v-model="filterParams.transmissionFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="filters__box-part">
              <div class="filters__box-title">количество мест</div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">2
                  <input type="radio" value="2" name="number" v-model="filterParams.seatsFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">5
                  <input type="radio" checked value="5" name="number" v-model="filterParams.seatsFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">7 и более 
                  <input type="radio"value="7" name="number" v-model="filterParams.seatsFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="filters__box-column">
            <div class="filters__box-part">
              <div class="filters__box-title">год выпуска</div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Не старше 3 лет
                  <input type="radio" value="2021:2024" name="year" v-model="filterParams.yearFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Любой
                  <input type="radio" checked value="any" name="year" v-model="filterParams.yearFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Не старше 5 лет
                  <input type="radio" value="2019:2024" name="year" v-model="filterParams.yearFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="filters__box-part">
              <div class="filters__box-title">привод</div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Передний
                  <input type="radio" checked value="FWD" name="drive-unit" v-model="filterParams.driveTypeFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Задний
                  <input type="radio" value="RWD" name="drive-unit" v-model="filterParams.driveTypeFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Полный
                  <input type="radio" value="AWD" name="drive-unit" v-model="filterParams.driveTypeFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="filters__box-column">
            <div class="filters__box-part">
              <div class="filters__box-title">Двигатель</div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Бензин
                  <input type="radio" checked value="gasoline" name="engine" v-model="filterParams.engineFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Дизель
                  <input type="radio" value="diesel" name="engine" v-model="filterParams.engineFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Электро/Гибрид
                  <input type="radio" value="hybrid" name="engine" v-model="filterParams.engineFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="filters__box-part">
              <div class="filters__box-title">ограничение пробега</div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Нет
                  <input type="radio" checked value="false" name="mileage" v-model="filterParams.mileageFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Есть
                  <input type="radio" value="true" name="mileage" v-model="filterParams.mileageFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="filters__box-field">
                <div class="radio">
                  <label class="radio-container">Любой
                  <input type="radio" value="any" name="mileage" v-model="filterParams.mileageFilter">
                  <span class="radio-checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="filters__box-bottom">
          <div class="filters__box-bottom-block">
            <div class="filters__box-bottom-title"><strong>Цена в сутки, руб.</strong></div>
            <div class="filters__box-field row form-select form-select-large">
              <input type="number" v-model="filterParams.ratePerDayFilter.price1" name="buster" list="options5" id="price" placeholder="от">
              <datalist id="options5">
                <option value="0">0</option>
                <option value="1000">1000</option>
                <option value="20000">20000</option>
              </datalist>
              <input type="number" v-model="filterParams.ratePerDayFilter.price2" name="buster" list="options6" id="price" placeholder="до">
              <datalist id="options6">
                <option value="100000">100000</option>
                <option value="200000">200000</option>
                <option value="300000">300000</option>
              </datalist>
            </div>
          </div>
          <div class="filters__box-bottom-block">
            <div class="filters__box-bottom-title"><strong>Депозит, руб.</strong></div>
            <div class="filters__box-field row form-select form-select-large">
              <input type="number" v-model="filterParams.depositFilter.price1" name="buster" list="options" id="deposit" placeholder="от">
              <datalist id="options">
                <option value="0">0</option>
                <option value="1000">1000</option>
                <option value="20000">20000</option>
              </datalist>
              <input type="number" v-model="filterParams.depositFilter.price2" name="buster" list="options1" id="deposit" placeholder="до">
              <datalist id="options1">
                <option value="0">0</option>
                <option value="1000">1000</option>
                <option value="20000">20000</option>
              </datalist>
            </div>
          </div>
          <div class="filters__box-bottom-block">
            <div class="filters__box-bottom-title"><strong>Объем двигателя, л</strong></div>
            <div class="filters__box-field row form-select form-select-large">
              <input v-model="filterParams.engineCapacityFilter.value1" type="number" name="engine" list="options3" id="engine-capacity" placeholder="от">
              <datalist id="options3">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </datalist>
              <input v-model="filterParams.engineCapacityFilter.value2" type="number" name="engine" list="options4" id="engine-capacity" placeholder="до">
              <datalist id="options4">
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </datalist>
            </div>
          </div>
        </div>
        <div class="filters__box-buttons">
          <input type="reset" @click="clearFilters" class="filters__box-link" value="Сбросить все фильтры">
          <button type="button" class="button button-accent button-rounded button-arrow button-medium" @click="$emit('chooseFilters', filterParams), showFilters = false"><span class="button-wrapper">Применить <span class="arrow-icon"></span></span></button>
        </div>
      </div>
    </form>
    <div class="filters__row">
      <div 
      class="filters__item background"
      :class="{'active': cars.activeClassId == item.id}"
      v-for="(item, index) in classList" :key="index" @click="$emit('chooseClass', item.id)">{{ item.name }}</div>
      <!-- <div class="filters__item background">Бизнес <span class="amount">70</span></div> -->
    </div>
  </div>
</template>

<style>
.filters__box {
  display: block;
}
</style>